import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { login_background1, Login_title } from "../../../assets/img";
import toast from "react-hot-toast";
import { NUMBER, URLS } from "../../redux/api/Constants";
import { post } from "../../redux/api/ApiHandler";

const Login = () => {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  const [data, setData] = useState({
    mobile: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "mobile") {
      if (value && !/^[6-9]/.test(value)) {
        return; // prevent entering invalid first digit
      }
    }

    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const navigaters = (res) => {
    console.log("res==>", res);
    switch (res?.role) {
      case "Super Admin":
        navigate("/dashboard");
        break;
      case "Inventory":
        navigate("/dashboard1");
        break;
      case "Technical":
        navigate("/dashboard1");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    let user_role = localStorage.getItem("role");
    if (localStorage.getItem("token")) {
      navigaters({ role: user_role });
    }
  }, []);

  const signin = async () => {
    const newErrors = {};
    if (!NUMBER.test(data.mobile) || data.mobile.length !== 10) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }
    if (!data.password || data.password.length < 4) {
      newErrors.password = "Password must be at least 4 characters";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setErrors({});

      let payload = {
        mobile: data.mobile,
        password: data.password,
      };
      setLoader(true);
      let res = await post(URLS.LOGIN, payload);
      setLoader(false);
      console.log("res", res);

      if (res?.status == "success") {
        localStorage.setItem("token", res?.token);
        localStorage.setItem("role", res?.role);
        localStorage.setItem("user", JSON.stringify(res?.user));
        localStorage.setItem("name", res?.user?.name);
        localStorage.setItem("admin_id", res?.user?.id);
        let arr = [1, 2, 3];
        if (arr.includes(res?.user?.role)) {
          toast.success(res?.message);
          navigaters(res);
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          toast.error("No user found");
        }
      }
    }
  };

  return (
    <div
      className="container_overall min-vh-100 login-page "
      style={{ backgroundImage: `url(${login_background1})` }}
    >
      <div className="col-lg-12 d-flex ac-jc">
        {/* Left Section */}
        <div className="col-lg-5 d-flex ac-jc login-left"></div>

        {/* Right Section */}
        <div className="col-lg-7 login-right">
          <div className="login-form">
            <div className="d-flex ac-jc">
              <img src={Login_title} className="Login_title" />
            </div>
            <h2 className="login-title black text-center f3 fs-xs-17 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mb-3 mt-3">
              Printer Management System
            </h2>
            <h2 className="login-title black text-center f3 fs-xs-17 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mb-2">
              Welcome
            </h2>
            {/* Mobile Input */}
            <div className="form-group text-start">
              <label className=" mb-0 mt-2 f2 fs-xs-15 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-17 fs-xxl-19 black">
                Mobile Number
              </label>
              <div className="login-input mt-1 d-flex align-items-center">
                <p className="me-2 mb-0 primary1">+91</p>
                <input
                  value={data.mobile}
                  onChange={handleChange}
                  name="mobile"
                  type="number"
                  placeholder="Enter mobile number"
                  maxLength={10}
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 10))
                  }
                />
              </div>
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>
            {/* Password Input */}
            <div className="form-group text-start mt-3">
              <label className=" mb-0 mt-2 f2 fs-xs-15 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-17 fs-xxl-19 black">
                Password
              </label>
              <div className="login-input mt-1 d-flex align-items-center">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.slice(0, 30))
                  }
                />
                <span
                  onClick={togglePassword}
                  className="password_color"
                  style={{ cursor: "pointer", paddingRight: "10px" }}
                >
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </span>
              </div>
              {errors.password && <p className="err">{errors.password}</p>}
            </div>
            <div className="d-flex ac-jc">
              <button
                type="submit"
                className="login-btn  mb-0 mt-3 f3 fs-xs-15 fs-sm-15 fs-md-16 fs-lg-16 fs-xl-17 fs-xxl-19 white"
                onClick={signin}
              >
                {loader ? (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  " Login"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
